import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ActionsSubject, Store } from '@ngrx/store';
import * as GeneralActions from '../../+state/general.actions';
import { ofType } from '@ngrx/effects';
import { map, take } from 'rxjs/operators';

@Injectable()
export class ColumnsResolver implements Resolve<boolean> {
  constructor(
    private _actionsStream: ActionsSubject,
    private _store: Store,
  ) {}

  public resolve(): Observable<boolean> {
    this._store.dispatch(GeneralActions.getColumnGroups());

    return this._actionsStream
      .pipe(
        ofType(GeneralActions.getColumnGroupsSuccess),
        map(() => true),
        take(1),
      );
  }
}
